import script from "./PrivateContribution.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateContribution.vue?vue&type=script&setup=true&lang=js"

import "./PrivateContribution.vue?vue&type=style&index=0&id=6829155e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6829155e"]])

export default __exports__